import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Util } from '@libs/utilities/util';
import { filter } from 'rxjs/operators';


@Injectable()
export class AddonGoogleTagManagerService {

	//** Window object to access the script functions */
	private readonly window: TypeAddonWindowGoogleTag;

	constructor(
		@Inject(DOCUMENT)
		private document: Document,
		private router 	: Router
	) {
		//0 - set the window object
		this.window = this.document.defaultView as TypeAddonWindowGoogleTag;

		//1 - track page view events on dynamic route changes
		this.trackPageViewEvents();
	}


	/**------------------------------------------------------
	 * Push Custom Event
	 */
	emitEvent(event: IAddonGoogleTagManagerEvent): void {
		this.pushOnDataLayer(event);
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private trackPageViewEvents() {

		//0 - are we in the browser?
		// > Note: only if we are in the browser we can access the cookies.
		// > If we are not in the browser we are the prerendering or server
		// > nodeJS process and don't have access to the window or document objects.
		if (!Util.Basic.isBrowser()) return;

		//1 - track the dynamic page views
		// > Note: this is required as page view events are only tracked correctly
		// > by default for pre rendered pages. If we have a single page webapp,
		// > where the content is rendered dynamically and no http call is made we
		// > need to emit out the page view events manually.
		this.router.events.pipe(
			filter((event: Event) => event instanceof NavigationEnd)
		).subscribe(() => {
			this.pushOnDataLayer({
				event 		  : 'page_view',
				page_location : window.location.href
			});
		});
	}

	private pushOnDataLayer(gtmEvent: IAddonGoogleTagManagerEvent) {
		this.window.dataLayer = this.window.dataLayer || [];
		this.window.dataLayer.push(gtmEvent);
	}
}


//** Types -------------------------------------- */
type TypeAddonWindowGoogleTag = Window & typeof globalThis & IAddonGoogleTag;


//** Interfaces --------------------------------- */
interface IAddonGoogleTag {
	dataLayer		: IAddonGoogleTagManagerEvent[];
}

interface IAddonGoogleTagManagerEvent {
	event 		  	: string;
	[key: string] 	: string;
}
